import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AppHeader } from "@/components/TopBar";
import { adminApi, LS } from "@/lib/apiClient";
import { toast } from "sonner";
import OverviewTab from "@/pages/admin/OverviewTab";
import IngestionTab from "@/pages/admin/IngestionTab";
import FacebookTab from "@/pages/admin/FacebookTab";
import TenantsTab from "@/pages/admin/TenantsTab";
import PersonasTab from "@/pages/admin/PersonasTab";
import { LayoutDashboard, UploadCloud, Building2, Bot, Facebook } from "lucide-react";

export default function AdminConsole() {
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(LS.adminKey)) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const r = await adminApi.get("/admin/modules");
        setModules(r.data.modules);
        setReady(true);
      } catch (e) {
        toast.error("Invalid admin session. Please re-enter your admin key.");
        localStorage.removeItem(LS.adminKey);
        navigate("/");
      }
    })();
  }, [navigate]);

  if (!ready) return <div className="min-h-screen" />;

  return (
    <div className="min-h-screen flex flex-col">
      <AppHeader />
      <div className="flex-1 mx-auto w-full max-w-[1500px] px-4 sm:px-6 lg:px-8 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-display font-semibold tracking-tight">Admin Console</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Securely ingest governed memory and manage tenant licensing — the raw workbook stays server-side.
          </p>
        </div>
        <Tabs defaultValue="overview">
          <TabsList className="bg-secondary/50">
            <TabsTrigger value="overview" data-testid="admin-tab-overview"><LayoutDashboard className="h-4 w-4 mr-1.5" />Overview</TabsTrigger>
            <TabsTrigger value="ingestion" data-testid="admin-tab-ingestion"><UploadCloud className="h-4 w-4 mr-1.5" />Ingestion</TabsTrigger>
            <TabsTrigger value="facebook" data-testid="admin-tab-facebook"><Facebook className="h-4 w-4 mr-1.5" />Social Memory</TabsTrigger>
            <TabsTrigger value="tenants" data-testid="admin-tab-tenants"><Building2 className="h-4 w-4 mr-1.5" />Tenants</TabsTrigger>
            <TabsTrigger value="personas" data-testid="admin-tab-personas"><Bot className="h-4 w-4 mr-1.5" />Personas</TabsTrigger>
          </TabsList>
          <TabsContent value="overview" className="mt-6"><OverviewTab modules={modules} /></TabsContent>
          <TabsContent value="ingestion" className="mt-6"><IngestionTab modules={modules} /></TabsContent>
          <TabsContent value="facebook" className="mt-6"><FacebookTab /></TabsContent>
          <TabsContent value="tenants" className="mt-6"><TenantsTab modules={modules} /></TabsContent>
          <TabsContent value="personas" className="mt-6"><PersonasTab /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
